.navigationContent {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
.NavigationHeader {
  align-items: center;
  display: flex;
  color: var(--paletteThemePrimary);
  padding: 4px;
  cursor: pointer;
  border-bottom: 1px solid var(--semanticColorsBodyDivider);
  .headerImage {
    padding: 12px;
    height: 40px;
  }
  .logoOverlay {
    position: absolute;
    top: 4px;
    right: 4px;
    height: 40px;
  }
  .testModeBadge {
    position: absolute;
    top: 36px;
    right: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #d83b01;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    pointer-events: none;
    transform: rotate(23deg);
  }
  font-size: 16px;
}

.openInNewTabIcon {
  padding-bottom: 4px;
  font-size: 10px;
}

.statusDot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  margin-left: 6px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.status-running {
  background: #22c55e;
}

.status-starting {
  background: #fbbf24;
}

.status-stopped {
  background: #94a3b8;
}

.status-failed {
  background: #ef4444;
}

.status-disabled {
  background: #cbd5f5;
}

.status-unknown {
  background: #cbd5f5;
}

.themeSwitchPanel {
  margin: 0 12px 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.themeSwitch {
  margin: 0;
  cursor: pointer;
  opacity: 0.7;
}

.themeSwitch:hover {
  opacity: 1;
}

:global(.darkTheme) .NavigationHeader {
  color: var(--paletteThemeLight);
}
